import styled from "styled-components"

export const Wrapper = styled.div`
  .rbc-event-label {
    display: none;
  }
`
